import { AnalyticProvider } from "./analytic.provider"
import { BlogProvider } from "./blog.provider"
import { GlobalProvider } from "./global.provider"
import { SearchProvider } from "./search.provider"
import { SubscriptionProvider } from "./subscription.provider"
import { MediaProvider } from "./media.provider"
import { ContactUsProvider } from "./contact-us.provider"
import { VacanciesProvider } from "./vacancies.provider"
import { DepartmentsProvider } from "./departments.provider"
import { LegalProvider } from "./legal.provider"
import { TeamPageProvider } from "./team-page.provider"
import { GDPRProvider } from "./gdpr.provider"
import { SaferDatingProvider } from "./safer-dating.provider"

export class AppProvider {
  AnalyticProvider!: AnalyticProvider
  BlogProvider!: BlogProvider
  GlobalProvider!: GlobalProvider
  SearchProvider!: SearchProvider
  SubscriptionProvider!: SubscriptionProvider
  MediaProvider!: MediaProvider
  ContactUsProvider!: ContactUsProvider
  VacanciesProvider!: VacanciesProvider
  DepartmentsProvider!: DepartmentsProvider
  LegalProvider!: LegalProvider
  TeamPageProvider!: TeamPageProvider
  GDPRProvider!: GDPRProvider
  SaferDatingProvider!: SaferDatingProvider

  init() {
    const globalProvider = new GlobalProvider()
    const analyticProvider = new AnalyticProvider()
    const blogProvider = new BlogProvider()
    const subscriptionProvider = new SubscriptionProvider()
    const searchProvider = new SearchProvider()
    const mediaProvider = new MediaProvider()
    const contactUsProvider = new ContactUsProvider()
    const vacanciesProvider = new VacanciesProvider()
    const departmentsProvider = new DepartmentsProvider()
    const legalProvider = new LegalProvider()
    const teamPageProvider = new TeamPageProvider()
    const gdprProvider = new GDPRProvider()
    const saferDatingProvider = new SaferDatingProvider()

    const ctx = {
      GlobalProvider: globalProvider,
      AnalyticProvider: analyticProvider,
      BlogProvider: blogProvider,
      SubscriptionProvider: subscriptionProvider,
      SearchProvider: searchProvider,
      MediaProvider: mediaProvider,
      ContactUsProvider: contactUsProvider,
      VacanciesProvider: vacanciesProvider,
      DepartmentsProvider: departmentsProvider,
      LegalProvider: legalProvider,
      TeamPageProvider: teamPageProvider,
      GDPRProvider: gdprProvider,
      SaferDatingProvider: saferDatingProvider,
    }

    // @ts-ignore
    globalProvider.setProviders(ctx)
    // @ts-ignore
    analyticProvider.setProviders(ctx)
    // @ts-ignore
    blogProvider.setProviders(ctx)
    // @ts-ignore
    subscriptionProvider.setProviders(ctx)
    // @ts-ignore
    searchProvider.setProviders(ctx)
    // @ts-ignore
    mediaProvider.setProviders(ctx)
    // @ts-ignore
    contactUsProvider.setProviders(ctx)
    // @ts-ignore
    vacanciesProvider.setProviders(ctx)
    // @ts-ignore
    departmentsProvider.setProviders(ctx)
    // @ts-ignore
    legalProvider.setProviders(ctx)
    // @ts-ignore
    teamPageProvider.setProviders(ctx)
    // @ts-ignore
    gdprProvider.setProviders(ctx)
    // @ts-ignore
    saferDatingProvider.setProviders(ctx)

    this.GlobalProvider = globalProvider
    this.AnalyticProvider = analyticProvider
    this.BlogProvider = blogProvider
    this.SubscriptionProvider = subscriptionProvider
    this.SearchProvider = searchProvider
    this.MediaProvider = mediaProvider
    this.ContactUsProvider = contactUsProvider
    this.VacanciesProvider = vacanciesProvider
    this.DepartmentsProvider = departmentsProvider
    this.LegalProvider = legalProvider
    this.TeamPageProvider = teamPageProvider
    this.GDPRProvider = gdprProvider
    this.SaferDatingProvider = saferDatingProvider
  }
}
